
export const syntaxHighlight = (completeStr, strToBeHighlighted) => {
    if (!completeStr) return ""; //Empty String
    return completeStr.replace(strToBeHighlighted, '<span class="highlight">' + strToBeHighlighted + '</span>');
}